export default __webpack_public_path__ + "static/media/centro_odontologico_charcas.665b52a0.jpg";